class FooterSignUp extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.updateSignUpForm()
  }

  updateSignUpForm() {
    const cssStyles = `
      [class^="_formHeader_"] {
        display: none !important;
      }

      [class^="_formFieldset_"] {
        display: flex !important;
        flex-direction: row !important;
        gap: 0 !important;
        border-bottom: 1px solid #000 !important;
        background-color: #f2f2f3 !important;
      }

      [class^="_formPhoneInputContainer_"] {
        gap: 0 !important;
      }

      [class^="_selectContainer_"],
      [class^="_selectToggle_"],
      [class^="_formPhoneInputField_"] {
        border: none !important;
        background-color: transparent !important;
        box-shadow: none !important;
        text-align: left !important;
      }

      [class^="_formInputFieldLabel_"] {
        left: 10px !important;
        top: 5px !important;
        width: fit-content !important;
        transform: none !important;
      }

      [class^="_formSubmitButton_"] {
        background-color: transparent !important;
        color: transparent !important;
        font-size: 0 !important;
      }

      [class^="_formSubmitButton_"]::after {
        content: "";
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url("data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M17.0151%2010.6604L9.50758%2018.3207M17.0151%2010.6604L9.50758%203.00008M17.0151%2010.6604H2.00003%22%20stroke%3D%22black%22/%3E%3C/svg%3E");
        background-size: contain;
        background-repeat: no-repeat;
        margin-left: 4px;
      }

      [class^="_formContainer_"] {
        min-height: 0 !important;
        max-width: 100% !important;
      }

      [class^="_formContainer_"] [class^="_formBannerHeading_"] {
        justify-content: start !important;
        font-family: var(--font-body-family) !important;
        font-style: normal !important;
        color: #000 !important;
        font-weight: 600 !important;
        font-size: 20px !important;
        line-height: 20px !important;
      }

      [class^="_formContainer_"] [class^="_textBody_"] {
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 16px !important;
        color: #000 !important;
        text-align: left !important;
        font-family: var(--font-body-family) !important;
      }

      [class^="_formBannerContainer_"] {
        margin-top: 0 !important;
      }

      [class^="_formError_"] {
        padding: 8px !important;
      }

      button[class^="_selectToggle_"] {
        min-width: 60px !important;
      }

      [class^="_formPhoneInputContainer_"] {
        grid-template-columns: minmax(0px, 60px) minmax(0px, 2.2fr) !important;
      }

      [class^="_formPhoneInputContainer_"] [class^="_arrowDownIcon_"] {
        display: none;
      }

      [class^="_formPhoneInputContainer_"] [class^="_selectToggle_"] {
        pointer-events: none;
        cursor: none;
      }

      [data-form-root] > div[class^="_container_"] {
        display: block;
      }

      [class^="_formPhoneInputContainer_"] [class^="_selectToggleText_"] {
        width: auto;
      }

    `;
    const observer = new MutationObserver(() => {
      const form = document.querySelector('form-embed');
      if (!form || !form.shadowRoot) { return }

      const style = document.createElement('style');
      style.textContent = cssStyles
      form.shadowRoot.appendChild(style);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

}

customElements.define('footer-signup', FooterSignUp);